<template>
    <div style="height: 100%" class="d-flex flex-column">
        <p class="text-display-medium font-weight-regular text-typography1">
            {{ title }}
        </p>
        <CalcStatsChips :calcId="calcId" :noLeftMargin="true" />
        <div class="overflow-y-auto styled-scrollbar flex-shrink-1 flex-grow-0">
            <p class="text-body-1 text-typography1">{{ description }}</p>
        </div>
    </div>
</template>
<script setup>
import CalcStatsChips from './CalcStatsChips.vue'

defineProps(['title', 'description', 'calcId'])
</script>
